import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IdcardOutlined, LineChartOutlined, LinkOutlined, TagOutlined, WalletOutlined } from "@ant-design/icons";
import { Grid, Menu, Tooltip, theme } from "antd";
import { observer } from "mobx-react";
import { useLocation, useNavigate } from "react-router-dom";
import { __ } from "../../../../../utils/i18n.js";
const AffiliateSideNav = observer(()=>{
    const screens = Grid.useBreakpoint();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { token } = theme.useToken();
    // Order is load-bearing: it mirrors the affiliate dashboard's documented
    // navigation sequence (Transactions first as the default landing page).
    const items = [
        {
            key: "",
            label: __("Transactions"),
            icon: /*#__PURE__*/ _jsx(LineChartOutlined, {})
        },
        {
            key: "links",
            label: __("Link generator"),
            icon: /*#__PURE__*/ _jsx(LinkOutlined, {})
        },
        {
            key: "coupons",
            label: __("Coupons"),
            icon: /*#__PURE__*/ _jsx(TagOutlined, {})
        },
        {
            key: "payouts",
            label: __("Payouts"),
            icon: /*#__PURE__*/ _jsx(WalletOutlined, {})
        },
        {
            key: "edit",
            label: __("Affiliate account data"),
            icon: /*#__PURE__*/ _jsx(IdcardOutlined, {}),
            tooltip: __("Edit invoice address, payment details, and preferences.")
        }
    ];
    // `/affiliate` (index route) renders TransactionsPage; the index key is "".
    const activeKey = pathname.split("/")[2] ?? "";
    const renderLabel = ({ label, tooltip })=>tooltip ? /*#__PURE__*/ _jsx(Tooltip, {
            title: tooltip,
            placement: "right",
            children: /*#__PURE__*/ _jsx("span", {
                children: label
            })
        }) : label;
    if (screens.md) {
        return /*#__PURE__*/ _jsx(Menu, {
            className: "rc-account-v2-affiliate-sidenav",
            mode: "inline",
            selectedKeys: [
                activeKey
            ],
            onSelect: ({ key })=>navigate(`/affiliate/${key}`),
            items: items.map((item)=>({
                    key: item.key,
                    label: renderLabel(item),
                    icon: item.icon
                }))
        });
    }
    // Mobile: a horizontal tab strip mirroring the top customer-center tabnav
    // (border-bottom underline on the active item, horizontal scroll with fade).
    // Antd's <Segmented> here would work functionally but its v5 markup omits
    // any DOM hook for the active item — only the animated thumb signals it —
    // so we render plain buttons instead and own the active styling explicitly.
    return /*#__PURE__*/ _jsx("nav", {
        className: "rc-account-v2-affiliate-tabnav",
        "aria-label": __("Affiliate sections"),
        children: items.map((item)=>{
            const { key, label, icon, tooltip } = item;
            const isActive = key === activeKey;
            const button = /*#__PURE__*/ _jsxs("button", {
                type: "button",
                className: `rc-account-v2-affiliate-tabnav__item${isActive ? " rc-account-v2-affiliate-tabnav__item--active" : ""}`,
                onClick: ()=>navigate(`/affiliate/${key}`),
                style: {
                    color: isActive ? token.colorPrimary : token.colorTextSecondary,
                    borderBottomColor: isActive ? token.colorPrimary : "transparent"
                },
                children: [
                    icon,
                    /*#__PURE__*/ _jsx("span", {
                        children: label
                    })
                ]
            }, key);
            return tooltip ? /*#__PURE__*/ _jsx(Tooltip, {
                title: tooltip,
                children: button
            }, key) : button;
        })
    });
});
export { AffiliateSideNav };
